import { useMasterUserSelector } from '../redux/selector';
import { UserRole } from '../model/enum';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { hasPermission } from '../utils/utils';

const usePermission = (roles: UserRole[]) => {
  const user = useMasterUserSelector();
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasPermission(roles, user)) {
      navigate('/');
      message.error('Bạn không có quyền truy cập nội dung này').then();
    }
  }, [roles, user]);
};

export default usePermission;
